module.exports = __webpack_public_path__ + "img/a01.a0db99e3.png";